module.exports = require('./helpers/bundle-url').getBundleURL('hSWUQ') + "logo.c51670a8.svg";